import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import { Box, Button, Card, CardContent, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Tooltip, Typography } from "@mui/material";

import { AiOutlineFileText } from "react-icons/ai";

import moment from "moment";

import { TablePaginationActions } from "../../../helpers/TablePaginationActions";

import { usePages } from "../../../hooks/usePages";

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { TableTheadStyle, TablePaddingStyle } from "../../../styles/TableStyle";
import { DialogContentStyle, DialogActionsStyle } from "../../../styles/DialogStyle";

import { Layout } from "../../../components/Layout";
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion";
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";

import { DialogDocumento } from "../../../dialogs/DialogDocumento";

import { DetalleListaAcuerdos, FinalizarListaAcuerdos, GenerarListaAcuerdos } from "../../../connections/tribunal/ListaAcuerdoConnection";

import { defaultDetalleListaAcuerdosResponse, DetalleListaAcuerdosResponse, AcuerdoProps } from "../../../interfaces/tribunal/ListaAcuerdosInterface";

export const GenerarListaAcuerdosPage = () => {

    const { Id } = useParams();

    const dispatch = useDispatch();

    const [rows, setRows] = useState<AcuerdoProps[]>( [] );
    const [rowsAll, setRowsAll] = useState( false );

    const [loading, setLoading] = useState( true );
    const [loadingGenerar, setLoadingGenerar] = useState( false );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [listaAcuerdos, setListaAcuerdos] = useState<DetalleListaAcuerdosResponse>( defaultDetalleListaAcuerdosResponse );

    const [documento, setDocumento] = useState<string>( '' );
    const [openDocumento, setOpenDocumento] = useState( false );

    const [documentoListaAcuerdos, setDocumentoListaAcuerdos] = useState<string>( '' );

    const [openDialogConfirmacion, setOpenDialogConfirmacion] = useState( false );
    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages( 10 );

    const handleGenerarVisualizar = () => {

        if ( documentoListaAcuerdos ) {

            setDocumento( documentoListaAcuerdos );
            setOpenDocumento( true );

        }
        else {

            setOpenDialogConfirmacion( true );

        }

    }

    const handleGenerarListaAcuerdos = async () => {

        if ( !Id ) return;

        setLoadingGenerar( true );

        await GenerarListaAcuerdos({ idListaAcuerdos: Id, acuerdos: rows }).then( resp => {

            setTimeout(() => {

                const { documento, success, message } = resp;

                if ( success ) {

                    setDocumentoListaAcuerdos( documento );

                    setDocumento( documento );
                    setOpenDocumento( true );

                    setLoadingGenerar( false );
                    setOpenDialogConfirmacion( false );
                    setRows( rows.filter( ({ selected }) => selected === true ) );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoadingGenerar( false );

                }

            }, 700);

        });
    }

    const handleFinalizar = async () => {

        if ( !Id ) return;

        setLoadingFinalizar( true );

        await FinalizarListaAcuerdos( Id ).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setLoadingFinalizar( false );
                    setOpenDialogConfirmacionFinalizar( false )
                    setProcesoTerminado( true );

                    setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );

                }
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    const handleSelectAll = ( value: boolean ) => {

        setRows( rows.map( elem => ({ ...elem, selected: value }) ) );
        setRowsAll( value );

    }

    const handleSelectRow = ( value: boolean, idAcuerdo: number ) => {

        setRows( rows.map(elem =>
            elem.idAcuerdo === idAcuerdo ? { ...elem, selected: value } : elem
        ));

    }

    useEffect(() => {

        async function Obtener() {

            if ( !Id ) return;

            setLoading( true );

            await DetalleListaAcuerdos( Id ).then( resp => {

                const { success, usuarioAsignado, asignadoMismoUsuario, documento, idEstatus, acuerdos } = resp;

                setTimeout(() => {

                    if ( success ) {

                        if ( idEstatus === 3 ) {

                            setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( idEstatus === 4 ) {

                            setProcesoCancelado( true );
                            setLoading( false );

                        }
                        else if ( !asignadoMismoUsuario ) {

                            setMensajeAsignacion( `La siguiente actividad se asignó a ${ usuarioAsignado }` );
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else {

                            setListaAcuerdos( resp );
                            setDocumentoListaAcuerdos( documento );
                            setRows( acuerdos.map( a => ({ ...a, selected: false }) ) );

                            setLoading( false );

                        }

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        if ( Id ) {
            Obtener();
        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Tribunal' }, { text: 'Lista de acuerdos' }, { text: 'Generar lista de acuerdos' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ mensajeFinalizacion !== '' } />
                    :
                        <>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 12, xs: 12 }}>

                                    <Card>

                                        <CardContent sx={{ p: 3 }}>

                                            <Grid container spacing={ 3 }>

                                                <Grid size={{ md: 12, xs: 12 }}>
                                                    <BoxHeaderInformacion numeroSeguimiento={ `GLA-${ listaAcuerdos.idListaAcuerdo }` } fecha={ listaAcuerdos.fecha ?? new Date() } />
                                                </Grid>

                                                <Grid size={{ md: 8, xs: 12 }}></Grid>

                                                <Grid size={{ md: 4, xs: 12 }}>

                                                    <Grid container spacing={ 3 }>

                                                        <Grid size={{ md: 8, xs: 12 }}>

                                                            <Button
                                                                fullWidth
                                                                color="secondary"
                                                                variant="outlined"
                                                                onClick={ handleGenerarVisualizar }
                                                                disabled={ documentoListaAcuerdos === '' && rows.filter( ({ selected }) => selected === true ).length === 0 }
                                                            >

                                                                { documentoListaAcuerdos !== '' ? 'Visualizar lista de acuerdos' : 'Generar lista de acuerdos' }

                                                            </Button>

                                                        </Grid>

                                                        <Grid size={{ md: 4, xs: 12 }}>

                                                            <Button
                                                                fullWidth
                                                                variant="contained"
                                                                disabled={ !documentoListaAcuerdos }
                                                                onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                            >
                                                                Finalizar
                                                            </Button>

                                                        </Grid>

                                                    </Grid>

                                                </Grid>

                                            </Grid>

                                        </CardContent>

                                    </Card>

                                </Grid>

                                <Grid size={{ md: 12, xs: 12 }}>

                                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                                        <Table>

                                            <TableHead sx={{ ...TableTheadStyle }}>

                                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Fecha</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Referencia</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Tipo de Juicio <br /> Amparo / Audiencia</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '12%', fontWeight: 'bold' }}>Tipo de acuerdo</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Actor(es) / Quejoso</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Demandado(s) / <br /> Tercer interesado</TableCell>
                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Reservado para</TableCell>

                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'end' }}>
                                                    {
                                                        !documentoListaAcuerdos
                                                        &&
                                                            <Tooltip title='Seleccionar todo'>
                                                                <Checkbox
                                                                    checked={ rowsAll }
                                                                    onChange={ (e) => handleSelectAll( e.target.checked ) }
                                                                    sx={{ bgcolor: 'white', borderRadius: 2, ':hover': { bgcolor: 'white' } }}
                                                                />
                                                            </Tooltip>
                                                    }
                                                    </TableCell>

                                                </TableRow>

                                            </TableHead>

                                            <TableBody>

                                                {
                                                    ( rowsPerPage > 0
                                                        ? rows.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                                        : rows
                                                    ).map( ({ idAcuerdo, fechaAcuerdo, referencia, noReferencia, tipoJuicio, tipoReservado, tipoAudiencia, tipoAmparo, idTipoAcuerdo, tipoAcuerdo, subTipoAcuerdo, actores, demandados, acuerdo, selected }, index) => (

                                                        <TableRow key={ index } >

                                                            <TableCell>

                                                                <Typography variant='subtitle1'>
                                                                    { moment( fechaAcuerdo ).format('DD-MM-YYYY') }
                                                                </Typography>

                                                                <Typography variant='caption' color='text.secondary'>
                                                                    { moment( fechaAcuerdo ).format('hh:mm a') }
                                                                </Typography>

                                                            </TableCell>

                                                            <TableCell>

                                                                <Typography variant="subtitle1">
                                                                    <strong>{ referencia }</strong>
                                                                </Typography>

                                                                { noReferencia && <Typography variant="subtitle2" fontWeight={ 'normal' } fontSize={ 14 }>{ noReferencia }</Typography> }

                                                            </TableCell>

                                                            <TableCell>

                                                                {
                                                                    idTipoAcuerdo === 8
                                                                    ?
                                                                        tipoAudiencia
                                                                    :
                                                                        idTipoAcuerdo === 12
                                                                        ?
                                                                            tipoAmparo
                                                                        :
                                                                            tipoJuicio
                                                                }

                                                            </TableCell>

                                                            <TableCell>
                                                                {
                                                                    subTipoAcuerdo
                                                                    ?
                                                                        <>

                                                                            <Typography variant="subtitle1" fontWeight={ 'bold' }>{ tipoAcuerdo }</Typography>
                                                                            <Typography variant="subtitle2" fontWeight={ 'normal' } fontSize={ 14 }>({ subTipoAcuerdo })</Typography>

                                                                        </>
                                                                    :
                                                                        <Typography variant="subtitle1" fontWeight={ 'bold' }>{ tipoAcuerdo }</Typography>
                                                                }
                                                            </TableCell>

                                                            <TableCell>{ actores?.join(', ') }</TableCell>

                                                            <TableCell>{ demandados?.join(', ') }</TableCell>

                                                            <TableCell>{ tipoReservado }</TableCell>

                                                            <TableCell sx={{ textAlign: 'end' }}>

                                                                <Tooltip title='Visualizar acuerdo'>
                                                                    <IconButton color="primary" onClick={ () => { setDocumento( acuerdo ); setOpenDocumento( true ); } }>
                                                                        <AiOutlineFileText fontSize={ 28 } />
                                                                    </IconButton>
                                                                </Tooltip>

                                                                {
                                                                    !documentoListaAcuerdos
                                                                    &&
                                                                        <Checkbox
                                                                            checked={ selected }
                                                                            onChange={ (e) => handleSelectRow( e.target.checked, idAcuerdo ) }
                                                                        />
                                                                }

                                                            </TableCell>

                                                        </TableRow>

                                                    ))
                                                }

                                                {
                                                    rows.length === 0
                                                    &&
                                                        <TableRow>
                                                            <TableCell
                                                                colSpan={ 8 }
                                                                align="center"
                                                            >
                                                                <Typography variant="caption" color='secondary'> No se encontraron registros </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                }

                                            </TableBody>

                                            <TableFooter>

                                                <TableRow>

                                                    <TableCell colSpan={ 2 }>
                                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { rows.length } </Typography>
                                                    </TableCell>

                                                    <TablePagination
                                                        rowsPerPageOptions={ [5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                                        colSpan={ 8 }
                                                        count={ rows.length }
                                                        rowsPerPage={ rowsPerPage }
                                                        page={ page }
                                                        onPageChange={ handleChangePage }
                                                        onRowsPerPageChange={ handleChangeRowsPerPage }
                                                        ActionsComponent={ TablePaginationActions }
                                                        labelRowsPerPage='Filas por página:'
                                                        labelDisplayedRows={
                                                            ({ from, to, count }) => {
                                                                return '' + from + '-' + to + ' de ' + count
                                                            }
                                                        }
                                                    />

                                                </TableRow>

                                            </TableFooter>

                                        </Table>

                                    </TableContainer>

                                </Grid>

                            </Grid>

                            <DialogDocumento
                                documento={ documento }
                                openDialog={ openDocumento }
                                handleCloseDialog={ () => setOpenDocumento( false ) }
                            />

                            <Dialog
                                fullWidth
                                maxWidth='xs'
                                open={ openDialogConfirmacion }
                                onClose={ () => {} }
                            >

                                <DialogTitle>
                                    Confirmación
                                </DialogTitle>

                                <DialogContent sx={ DialogContentStyle }>

                                    <DialogContentText>
                                        ¿Desea generar la lista de acuerdos?
                                    </DialogContentText>

                                </DialogContent>

                                <DialogActions sx={ DialogActionsStyle }>

                                    <Button color='secondary' disabled={ loadingGenerar } onClick={ () => setOpenDialogConfirmacion( false ) }> Cancelar </Button>
                                    <Button loading={ loadingGenerar } onClick={ handleGenerarListaAcuerdos } variant='contained' > Aceptar </Button>

                                </DialogActions>

                            </Dialog>

                            <Dialog
                                fullWidth
                                maxWidth='xs'
                                open={ openDialogConfirmacionFinalizar }
                                onClose={ () => {} }
                            >

                                <DialogTitle>
                                    Confirmación
                                </DialogTitle>

                                <DialogContent sx={ DialogContentStyle }>

                                    <DialogContentText>
                                        ¿Desea finalizar la generación de la lista de acuerdos?
                                    </DialogContentText>

                                </DialogContent>

                                <DialogActions sx={ DialogActionsStyle }>

                                    <Button color='secondary' disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar( false ) }> Cancelar </Button>
                                    <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>

                                </DialogActions>

                            </Dialog>

                        </>
            }

        </Layout>
    )
}
